export const messages = {
  en: {
    privilegeGroup: {
      addPrivilegeGroup: 'Add Privilege Group',
      privilegeGroup: 'Privilege Group',
      roleName: 'Role Name',
      roleNamePlaceholder: 'Required, please enter role name',
      roleNameRequired: 'Role name is required',
      roleNameLength: 'Role name must be between 2-10 characters',
      roleDesc: 'Role Description',
      roleDescPlaceholder: 'Optional, please enter role description',
      roleDescLength: 'Role description cannot exceed 200 characters',
      addRole: 'Add Role',
      editRole: 'Edit Role',
      save: 'Save',
      cancel: 'Cancel',
      addSuccess: 'Added successfully',
      editSuccess: 'Modified successfully',
      confirmOperation: 'Please confirm your operation',
      deleteWarning: 'Deleting privilege group will also delete all privileges under it',
      confirmDelete: 'Confirm to delete role',
      deleteSuccess: 'Deleted successfully',
      pointWrong: 'Wrong click'
    }
  },
  zh: {
    privilegeGroup: {
      addPrivilegeGroup: '添加权限组',
      privilegeGroup: '权限组',
      roleName: '角色名称',
      roleNamePlaceholder: '必填，请填写角色名称',
      roleNameRequired: '角色名称不能为空',
      roleNameLength: '角色名称长度必须在2位至10位',
      roleDesc: '角色描述',
      roleDescPlaceholder: '选填，请填写角色描述',
      roleDescLength: '角色描述长度不能超过200位',
      addRole: '添加角色',
      editRole: '编辑角色',
      save: '保存',
      cancel: '取消',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      confirmOperation: '请确认您的操作',
      deleteWarning: '删除权限组同时会删除权限组下的所有权限',
      confirmDelete: '确认是否删除角色',
      deleteSuccess: '删除成功',
      pointWrong: '点错了'
    }
  }
}